import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteLifePermissions extends BaseScenesPermissions {}

export default MultiquoteLifePermissions
